module.exports = __webpack_public_path__ + "static/media/the_traveling_seven_family_202.90315c73.jpeg";